var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('a',{attrs:{"href":_vm.mapurl,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.google_map_url,"alt":_vm.name}})]),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1409e2f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StaticMap.vue
// module id = 2B1H
// module chunks = 0